import { MenuItem, TextField } from '@mui/material';
import React from 'react';
import { Field, ErrorMessage, Formik } from 'formik';
import * as Yup from 'yup';

export default function CadastroAnuncianteForm2({ initialValues, onSubmit }) {

    // Validação com Yup
    const validationSchema = Yup.object().shape({
        endereco: Yup.string().required('Preencha o endereço'),
        numero: Yup.string().required('Preencha o número do endereço'),
        complemento: Yup.string(),
        bairro: Yup.string().required('Digite o seu bairro'),
        cep: Yup.string().required('Preencha o CEP'),
        cidade: Yup.string().required('Digite o nome da sua cidade'),
        estado: Yup.string().required('Escolha o estado'),
    });

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >
            {({ handleChange, values }) => (
                <Form>
                    <Field
                        name="endereco"
                        as={TextField}
                        fullWidth
                        label="Endereço"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.endereco}
                        error={Boolean(ErrorMessage.endereco)}
                        helperText={<ErrorMessage name="endereco" />}
                    />
                    <Field
                        name="numero"
                        as={TextField}
                        fullWidth
                        label="Número"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.numero}
                        error={Boolean(ErrorMessage.numero)}
                        helperText={<ErrorMessage name="numero" />}
                    />
                    <Field
                        name="complemento"
                        as={TextField}
                        fullWidth
                        label="Complemento"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.complemento}
                        error={Boolean(ErrorMessage.complemento)}
                        helperText={<ErrorMessage name="complemento" />}
                    />
                    <Field
                        name="bairro"
                        as={TextField}
                        fullWidth
                        label="Bairro"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.bairro}
                        error={Boolean(ErrorMessage.bairro)}
                        helperText={<ErrorMessage name="bairro" />}
                    />
                    <Field
                        name="cep"
                        as={TextField}
                        fullWidth
                        label="CEP"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.cep}
                        error={Boolean(ErrorMessage.cep)}
                        helperText={<ErrorMessage name="cep" />}
                    />
                    <Field
                        name="cidade"
                        as={TextField}
                        fullWidth
                        label="Cidade"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.cidade}
                        error={Boolean(ErrorMessage.cidade)}
                        helperText={<ErrorMessage name="cidade" />}
                    />
                    <Field
                        name="estado"
                        as={TextField}
                        fullWidth
                        label="Estado"
                        select
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.estado}
                        error={Boolean(ErrorMessage.estado)}
                        helperText={<ErrorMessage name="estado" />}
                    >
                        {['RJ', 'SP'].map((item, ind) => (
                            <MenuItem value={item} key={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Field>
                    <Button type="submit" color="primary" variant="contained">
                        Enviar
                    </Button>
                </Form>
            )}
        </Formik>
    );
}
